<!--
 * @Descripttion: 
 * @version: 
 * @Author: xzx
 * @Date: 2021-01-07 16:59:48
 * @LastEditors: xzx
 * @LastEditTime: 2021-02-23 11:14:35
-->
<template>
    <div :ref="setRef" style="position: absolute; width: 500px; height: 300px;"></div>
</template>

<script>
import * as echarts from 'echarts'
// import 'echarts/theme/tw_dark.js'
import twDark from '../../../public/tw_dark'
import { onMounted, reactive, watchEffect } from "vue";
import messageService from '../../services/message.service'

export default {
    name: "tw-ws-radar",
    
    setup(props) {
        let myRef;

        const setRef = el => {
            myRef = el;
        }

        let mockJson = reactive({"data":{
            "indicator":[
                {"name":"销售","max":650},
                {"name":"管理","max":1600},
                {"name":"信息技术","max":3000},
                {"name":"客服","max":3800},
                {"name":"研发","max":5200},
                {"name":"市场","max":2500}
            ],
            "series":[{"name":"雷达图","data":[
                {
                    value : [430, 1000, 1600, 3500, 5000, 1900],
                    areaStyle: {
                        opacity: 0.4
                    },
                    name : '预算分配'
                },
                {
                    value : [600, 1400, 2800, 2800, 3200, 2400],
                    areaStyle: {
                        opacity: 0.2
                    },
                    name : '实际开销'
                }
            ]}]}});

        const dataInit = function() {
            if(mockJson && mockJson.data && mockJson.data.series){
                mockJson.data.series.forEach(function(val){
                    val.type = 'radar';
                })
            }
        }

        const echartInit = () =>{
            echarts.registerTheme('tw_dark', twDark)
            var myChart = echarts.init(myRef, 'tw_dark');
            // 指定图表的配置项和数据
            var option = {
                title: {
                    text: props.title
                },
                legend: {
                    show: props.legendShow
                },
                tooltip: {
                    show: true
                },
                radar: {
                    radius:'60%',
                    indicator: mockJson.data.indicator,
                    splitNumber: props.splitNumber,     //环数
                    shape: props.shape?'circle':'polygon',    //背景形状
                    splitArea: {
                        show: props.splitArea
                    },      //背景是否不透明
                    splitLine: {
                        lineStyle: {
                            color: [
                                'rgba(238, 197, 102, 0.1)', 'rgba(238, 197, 102, 0.2)',
                                'rgba(238, 197, 102, 0.4)', 'rgba(238, 197, 102, 0.6)',
                                'rgba(238, 197, 102, 0.8)', 'rgba(238, 197, 102, 1)'
                            ].reverse()
                        }
                    }       //环线深浅
                },
                series: mockJson.data.series
            };
            // 使用刚指定的配置项和数据显示图表。
            myChart.setOption(option);
        }

        onMounted(()=>{
            watchEffect(() => {
                const data = props.data_source && props.data_source.datas

                if (data) {
                    if (data.data && data.data.series && data.data.indicator) {
                        mockJson = reactive(props.data_source.datas)
                    } else {
                        messageService.error('雷达图：请检查【数据源】数据格式');
                        mockJson = reactive({
                            data: {
                                categories: [],
                                series: []
                            }
                        })
                    }
                }
                dataInit()
                echartInit()
            })
        })

        return {
            setRef,
            echartInit
        };

    },
    props: {
        title: String,
        legendShow: {
            type: Boolean,
            default: true
        },
        data_source: {
            type: Object,
            default: function() {
                return { }
            }
        },
        splitNumber: {
            type: Number,
            default: 5
        },
        shape: {
            type: Boolean,
            default: false
        },
        splitArea: {
            type: Boolean,
            default: false
        }
    }
  }
</script>

<style>

</style>